/* DORI Kinetic motion.
   Reveals are CSS-transition + IntersectionObserver (robust; the theme bundles
   its own GSAP whose ticker conflicts with time-based tweens). GSAP is used
   ONLY for scroll-scrub parallax, which is driven by scroll position and works.
   Everything degrades to fully visible without JS or with reduced-motion. */
(function () {
  function ready(fn) { document.readyState !== 'loading' ? fn() : document.addEventListener('DOMContentLoaded', fn); }

  ready(function () {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // ---------- Reveals (CSS-driven) ----------
    if (!reduce && 'IntersectionObserver' in window) {
      document.documentElement.classList.add('dori-kin');

      // Hero: reveal on load (next frame).
      document.querySelectorAll('[data-dori-khero]').forEach(function (hero) {
        requestAnimationFrame(function () { requestAnimationFrame(function () { hero.classList.add('is-in'); }); });
      });

      // Scroll reveals for panels + other dori sections.
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.1 });
      document.querySelectorAll('[data-dori-panel], .dori-split, .dori-manifesto, .dori-rail, .dori-colhead').forEach(function (el) { io.observe(el); });

      // Failsafe: never leave anything hidden.
      setTimeout(function () {
        document.querySelectorAll('.dori-kin [data-dori-panel]:not(.is-in), .dori-kin .dori-split:not(.is-in), .dori-kin .dori-manifesto:not(.is-in), .dori-kin .dori-rail:not(.is-in), .dori-kin .dori-colhead:not(.is-in)').forEach(function (el) { el.classList.add('is-in'); });
      }, 2500);
    }

    // ---------- Parallax (GSAP scrub only) ----------
    var g = window.gsap, ST = window.ScrollTrigger;
    if (reduce || !g || !ST) return;
    g.registerPlugin(ST);

    document.querySelectorAll('[data-dori-khero]').forEach(function (hero) {
      var media = hero.querySelector('[data-khero-media]');
      if (media) g.fromTo(media, { yPercent: -4 }, { yPercent: 7, ease: 'none', scrollTrigger: { trigger: hero, start: 'top top', end: 'bottom top', scrub: true } });
    });

    document.querySelectorAll('[data-dori-panel]').forEach(function (panel) {
      var word = panel.querySelector('[data-panel-word]');
      var media = panel.querySelector('[data-panel-media]');
      var flip = panel.classList.contains('is-flip');
      if (word) g.fromTo(word, { xPercent: flip ? 14 : -14 }, { xPercent: flip ? -14 : 14, ease: 'none', scrollTrigger: { trigger: panel, start: 'top bottom', end: 'bottom top', scrub: true } });
      if (media) g.fromTo(media, { yPercent: 12 }, { yPercent: -12, ease: 'none', scrollTrigger: { trigger: panel, start: 'top bottom', end: 'bottom top', scrub: true } });
    });

    window.addEventListener('load', function () { ST.refresh(); });
  });
})();
